import { render, staticRenderFns } from "./packageList.vue?vue&type=template&id=b3657b20&scoped=true"
import script from "./packageList.vue?vue&type=script&lang=js"
export * from "./packageList.vue?vue&type=script&lang=js"
import style0 from "./packageList.vue?vue&type=style&index=0&id=b3657b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3657b20",
  null
  
)

export default component.exports